/**
 * 常用页面路由
 */
export enum PageEnum {
  /** 登录页 */
  BASE_LOGIN = '/login',
  /** 首页 */
  BASE_HOME = '/index',
  ERROR_PAGE = '/404',
  BUILDING = '/building',
  LOGINOUT = '/loginout',
}
